import { IOutOfServiceSettings, DeploymentGroupType } from 'dto/deployment/deployment-group-dto';
import { ISaveDeploymentProps } from 'dto/deployment/deployment-dto';
import { ComponentDto } from 'dto/raptor-component.dto';
import { ComponentVersionDto } from 'dto/raptor-component-version.dto';
import { DeviceGroupDto } from 'dto/device-group-dto';

export interface IAssureDeploymentDraft {
    releaseId?: number;
    removalPackages: string[];
    selectedDeviceGroups: DeviceGroupDto[];
    allowDPUOverride: boolean;
    allowDownloadOnly: boolean;
    selectedScheduleDate?: Date;
    selectedInstallationDate?: Date;
    outOfServiceSettings?: IOutOfServiceSettings;
}

export interface IRaptorDeploymentDraft {
    selectedComponents: ComponentDto[];
    selectedComponentVersions: Record<string, ComponentVersionDto>;
    selectedScheduleDate?: Date;
}

export enum RaptorComponentCompareStatus {
    ADD = 'add',
    REMOVE = 'remove',
    CHANGE = 'change',
    NO_CHANGE = 'noChange',
    NONE = 'none',
}

export interface IRaptorComponentCompareVersion {
    componentUuid?: string;
    componentName: string;
    componentVersionUuid?: string;
    version?: string;
}

export interface IRaptorComponentCompareItem {
    index: number;
    status: RaptorComponentCompareStatus;
    componentVersion?: IRaptorComponentCompareVersion;
}

export interface IRaptorComponentCompareState {
    target: {
        label: string;
        items: IRaptorComponentCompareItem[];
    };
    current: {
        label: string;
        items: IRaptorComponentCompareItem[];
    };
}

export type DeploymentFlowDraft =
    | { type: DeploymentGroupType.ASSURE; values: IAssureDeploymentDraft }
    | { type: DeploymentGroupType.RAPTOR; values: IRaptorDeploymentDraft };

export type TNewDeploymentProps = Omit<ISaveDeploymentProps, 'groupId'>;

export const createAssureDeploymentDraft = (): IAssureDeploymentDraft => ({
    removalPackages: [],
    selectedDeviceGroups: [],
    allowDPUOverride: false,
    allowDownloadOnly: false,
});

export const createRaptorDeploymentDraft = (): IRaptorDeploymentDraft => ({
    selectedComponents: [],
    selectedComponentVersions: {},
});
